// Constants to be shared between reducers and actions files.

export const FETCH_TOP_STORY_IDS = 'FETCH_TOP_STORY_IDS';
export const FETCH_TOP_STORY_ITEM = 'FETCH_TOP_STORY_ITEM';

export const FETCH_NEW_STORY_IDS = 'FETCH_NEW_STORY_IDS';
export const FETCH_NEW_STORY_ITEM = 'FETCH_NEW_STORY_ITEM';

export const FETCH_BEST_STORY_IDS = 'FETCH_BEST_STORY_IDS';
export const FETCH_BEST_STORY_ITEM = 'FETCH_BEST_STORY_ITEM';

export const FETCH_ASK_STORY_IDS = 'FETCH_ASK_STORY_IDS';
export const FETCH_ASK_STORY_ITEM = 'FETCH_ASK_STORY_ITEM';

export const FETCH_SHOW_STORY_IDS = 'FETCH_SHOW_STORY_IDS';
export const FETCH_SHOW_STORY_ITEM = 'FETCH_SHOW_STORY_ITEM';

export const FETCH_JOB_IDS = 'FETCH_JOBS_IDS';
export const FETCH_JOB_ITEM = 'FETCH_JOB_ITEM';

export const FETCH_COMMENT_ITEM = 'FETCH_COMMENT_ITEM';

export const FETCH_LIMIT = 150;